import { VideoCallCredentialsSliceState } from '../slices/videoCallCredentialsSlice';
import { RootState } from '../store';

export const selectVideoCallCredentials = (state: RootState): VideoCallCredentialsSliceState =>
  state.videoCallCredentials;
